import { LocationStateType } from '../types/LocationStateType';
import { useLocation } from 'react-router-dom';

export const useAppLocation = (): LocationStateType => useLocation() as LocationStateType;
